import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import Icon4 from "../../images/market-positioning (1).png";
import Icon5 from "../../images/socialmarketW.svg";

import { NavLink } from "react-router-dom";
// Main component for SolutionMarketplace
export default function SolutionMarketplace() {
  const apps = [
  
    {
      href: "/pSolution",
      image: Icon4,
      title: "pSolution",
    },

    {
      href: "/server-solution",
      image: Icon5,
      title: "ServerSolution",
    },
    
  ];

  return (
    <div maxwidth={12} className="businessPartnerContainer explore-marketplace-bg">
      <Container maxWidth="sm" className="gridSection gridSection--mod">
        <Grid container={true} alignItems="center" spacing={1} direction="row">
          {apps.map((e,index) => {
            return (
              <Grid
              key={index}
                id="ecoSystemView_link"
                className="hoverEffect mb-3"
                item
                md={6}
                sm={4}
                xs={6}
              >
                {/* Navigation link to respective solution */}
                <NavLink to={e.href}>
                  {/* Solution image */}
                  <img src={e.image} alt="ecoSystem & Mobile Apps View " />
                  {/* Solution title */}
                  <h4>{e.title}</h4>
                </NavLink>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
}
